/* eslint-disable */
import React, { useContext } from 'react';
import Modal from 'modules/common/components/Modal';
import { withRouter } from 'react-router-dom';
import { ModalContext } from 'App';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import withForm from 'modules/common/hoc/withForm';
import * as action from '../action';
import * as c from '../constant';

function ForPickupModal({
  title,
  status,
  createTextArea,
  transactionInfo,
  selected,
  approving,
  formData,
  showTransaction,
  approveTransaction,
}) {
  const setModal = useContext(ModalContext);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnForPickupModal = (e) => {
    e.preventDefault();
    // const status = _.get(transactionInfo, 'attributes.delivery_location') || 0;

    approveTransaction(
      selected,
      {
        remarks: formData.remarks,
        status: status,
      },
      () => {
        showTransaction(selected);
        setModal({ isOpen: false });
      }
    );
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnForPickupModal}>
        <div className="row">
          <div className="col-12 form-group">
            <label>
              Are you sure you want to tag this application {title}?
            </label>
            {createTextArea(
              {
                key: 'remarks',
                label: `Remarks:`,
              },
              { maxLength: '500', rows: '15' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={approving}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-danger"
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  ml-3 "
          >
            <span className="font-weight-bold">
              {approving ? <i className="fa fa-spin fa-spinner" /> : `Confirm`}
            </span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ForPickupModal.propTypes = {
  title: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  approving: PropTypes.bool.isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  selected: PropTypes.string.isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  approving: _.get(api, 'loading', []).indexOf(c.APPROVE_TRANSACTION) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(ForPickupModal);
